import { BaseRender } from './BaseRender';
import { Graphics } from './Graphics';
import { SceneManager } from './SceneManager';
import { CameraManager } from './CameraManager';

class NormalRender extends BaseRender {
  render() {
    Graphics.clear(undefined, CameraManager.current, true, true);
    Graphics.render(SceneManager.current, CameraManager.current);
  }
}

export { NormalRender };
